import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CaseView } from 'src/app/digigov/models/caseview.model';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}
@Component({
  selector: 'app-parallel-send-back',
  templateUrl: './parallel-send-back.component.html',
  styleUrls: ['./parallel-send-back.component.scss'],
})
export class ParallelSendBackComponent implements OnInit {
  message: any;
  docId: any;
  jobId: any;
  noteContent: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialogRef: MatDialogRef<ParallelSendBackComponent>,
    public translate: TranslateService,
    private messageDisplayService: MessageDisplayService
  ) {}

  ngOnInit(): void {
    console.log('notingVOArray', this.data?.selectedData[0]?.notingsVOArr);
  }

  onParallelSendBack() {
    let caseDataArray = this.data?.selectedData;
    for (let data of caseDataArray) {
      let dataForPost = {
        parallelFileId: data.docId,
        appTypeId: data.appTypeId, //1,
        notingsVOArray: this.data?.selectedData[0]?.notingsVOArr,
        stageId: data.stageId,
        statusId: data.statusId,
      };

      this.http
        .post('/workflow/send-back-parallel-file', dataForPost)
        .subscribe((res: any) => {
          this.dialogRef.close(true);
        });
    }
  }
}
